import React from 'react';

export const STEP_LABELS = {
  consent: 'Consent', accommodations: 'Accommodations', tech: 'Tech check', identity: 'ID check', room: 'Interview',
};

const Steps = ({ steps, current }) => {
  const idx = steps.indexOf(current);
  return (
    <nav className="iv-steps" aria-label="Interview steps" data-testid="candidate-steps">
      {steps.map((s, i) => (
        <span key={s} className={`iv-step ${i < idx ? 'is-done' : i === idx ? 'is-current' : ''}`} data-testid={`candidate-step-${s}`}>
          {i + 1}. {STEP_LABELS[s]}
        </span>
      ))}
    </nav>
  );
};

export const CandidateShell = ({ ctx, steps, current, children }) => (
  <div className="iv iv-page" data-testid="ai-candidate-page">
    <header className="iv-top">
      <div className="iv-row" style={{ gap: '0.6rem' }}>
        <img src="/chire-icon.png" alt="CHIRE" width={28} height={28} style={{ borderRadius: 6 }} />
        <span style={{ fontWeight: 800, letterSpacing: '0.02em' }}>
          CHIRE <span style={{ fontWeight: 500, opacity: 0.7 }}>Interview</span>
        </span>
      </div>
      {ctx && (
        <div className="iv-top-meta" data-testid="candidate-job-meta">
          <div style={{ color: '#fff', fontWeight: 700 }}>{ctx.job_title}</div>
          {ctx.company_name && <div>{ctx.company_name}</div>}
        </div>
      )}
    </header>
    <main className="iv-wrap">
      {steps && steps.includes(current) && <Steps steps={steps} current={current} />}
      {children}
    </main>
  </div>
);
